import { logWrapper } from '../utils';

export default {
  signerModel: [
    'runtimeConstant',
    function (runtimeConstant) {
      function Signer(data) {
        this.user_name = data ? data.user_name : '';
        this.email = data ? data.email : '';
        this.signed = data ? data.signed : '';
      }

      function getUserName() {
        return this.user_name;
      }

      function getEmail() {
        return this.email;
      }

      function getSigned() {
        return this.signed;
      }

      function run() {
        try {
          Signer.prototype = {
            getUserName: logWrapper(
              getUserName,
              runtimeConstant.isDebugModelsInternals
            ),
            getEmail: logWrapper(
              getEmail,
              runtimeConstant.isDebugModelsInternals
            ),
            getSigned: logWrapper(
              getSigned,
              runtimeConstant.isDebugModelsInternals
            ),
          };

          return Signer;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
